export default __webpack_public_path__ + "static/speed-gauge-02-tr-2ae6a348f31aeedbce6c655634dd2406.png";